import { render, staticRenderFns } from "./AccountAuthority.vue?vue&type=template&id=650d201e"
import script from "./AccountAuthority.vue?vue&type=script&lang=ts&setup=true"
export * from "./AccountAuthority.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./AccountAuthority.vue?vue&type=style&index=0&id=650d201e&prod&module=true&lang=stylus"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports